import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SaleList from '../components/SaleList';

const Sales = () => {
  const [sales, setSales] = useState([]);
  const [formData, setFormData] = useState({ client: '', amount: 0, status: 'pending' });

  const fetchSales = async () => {
    try {
      const response = await axios.get('https://venticrm.unsoloclic.mx/api/sales');
      setSales(response.data);
    } catch (err) {
      console.error('Error obteniendo ventas:', err);
    }
  };

  useEffect(() => {
    fetchSales();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('http://localhost:5000/api/sales', formData);
      fetchSales(); // Recargar la lista de ventas
      setFormData({ client: '', amount: 0, status: 'pending' }); // Limpiar el formulario
    } catch (err) {
      console.error('Error registrando venta:', err);
    }
  };

  return (
    <div>
      <h1>Ventas</h1>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Cliente"
          value={formData.client}
          onChange={(e) => setFormData({ ...formData, client: e.target.value })}
          required
        />
        <input
          type="number"
          placeholder="Monto"
          value={formData.amount}
          onChange={(e) => setFormData({ ...formData, amount: parseFloat(e.target.value) })}
          required
        />
        <select
          value={formData.status}
          onChange={(e) => setFormData({ ...formData, status: e.target.value })}
        >
          <option value="pending">Pendiente</option>
          <option value="paid">Pagado</option>
          <option value="overdue">Atrasado</option>
        </select>
        <button type="submit">Registrar Venta</button>
      </form>
      <SaleList sales={sales} fetchSales={fetchSales} />
    </div>
  );
};

export default Sales;